import React from 'react'
import { Box, type Sx } from '@mantine/core'
import StandardInput, { type StandardInputProps } from './StandardInput'

const rowSx: Sx = {
  display: 'grid',
  gridTemplateColumns: 'minmax(0, 1fr) auto',
  alignItems: 'flex-end',
  columnGap: 8,
  width: '100%',
  minWidth: 0,
  boxSizing: 'border-box'
}

export interface CommentInputRowProps {
  input: StandardInputProps;
  /** Submit button or other trailing control (e.g. Mantine Button). */
  action: React.ReactNode;
  sx?: Sx;
}

/**
 * Full-width comment/reply bar: input + action on one row.
 * Use inside nested comment cards (Slop post, drawer) where Mantine Group + flex often collapses width.
 */
export default function CommentInputRow ({ input, action, sx }: CommentInputRowProps) {
  return (
    <Box data-testid="comment-input-row" sx={[rowSx, ...(sx ? (Array.isArray(sx) ? sx : [sx]) : [])]}>
      <StandardInput {...input} fillMode="grid" />
      <Box component="span" sx={{ flexShrink: 0, whiteSpace: 'nowrap' }}>
        {action}
      </Box>
    </Box>
  )
}
